import simpleSoilAttribute from './simpleSoilAttribute';

export const FROST_ACTION = simpleSoilAttribute({
  key: 'Frost Action',
  ruleId: '52',
  shortFormData: { AggregationMethod: 'Dominant Condition' },
});
